<!--
 * @Author: xuhuan
 * @Date: 2023-07-12 10:03:41
 * @Description: file content
 * @LastEditors: xuhuan
 * @LastEditTime: 2023-08-01 09:50:58
-->
<template>
  <router-view/>
</template>

<style lang="scss">
@import url(./styles/common.scss);
@import url(./styles/index.scss);
</style>
